/**
 * @namespace {BX.UI}
 */
export default class ButtonColor
{
	static DANGER = 'ui-btn-danger';
	static DANGER_DARK = 'ui-btn-danger-dark';
	static DANGER_LIGHT = 'ui-btn-danger-light';
	static SUCCESS = 'ui-btn-success';
	static SUCCESS_DARK = 'ui-btn-success-dark';
	static SUCCESS_LIGHT = 'ui-btn-success-light';
	static PRIMARY_DARK = 'ui-btn-primary-dark';
	static PRIMARY = 'ui-btn-primary';
	static SECONDARY = 'ui-btn-secondary';
	static SECONDARY_LIGHT = 'ui-btn-secondary-light';
	static WARNING_LIGHT = 'ui-btn-warning-light';
	static LINK = 'ui-btn-link';
	static LIGHT = 'ui-btn-light';
	static LIGHT_BORDER = 'ui-btn-light-border';
	static AI = 'ui-btn-color-ai';
	static BASE_LIGHT = 'ui-btn-base-light';
	static COLLAB = 'ui-btn-collab';
	static PRIMARY_BORDER = 'ui-btn-primary-border';
	static CURTAIN_PRIMARY = 'ui-btn-primary-curtain';
	static CURTAIN_WARNING = 'ui-btn-primary-warning';
}
